import Vue from "vue";

Vue.component("disclaimer", {
    props: ["shortContent", "longContent", "language"],
    data() {
        return {
            disclaimerShown: false,
            loading: true,
            shortTitle: null,
            shortValue: null,
            longTitle: null,
            longValue: null
        };
    },
    mounted() {
        this.getShortContent();
    },
    methods: {
        getShortContent: function () {
            const self = this;

            self.loading = true;
            self.$services.staticContents.getContent({
                type: self.shortContent,
                language: this.language
            }).then((data) => {
                self.loading = false;
                if (data != null) {
                    self.shortTitle = data.title;
                    self.shortValue = data.content;
                }
            });
        },
        showDisclaimer() {
            const self = this;

            self.$services.staticContents.getContent({
                type: self.longContent,
                language: this.language
            }).then((data) => {
                if (data != null) {
                    self.disclaimerShown = true;
                    self.longTitle = data.title;
                    self.longValue = data.content;
                }
            });
        },
        discard() {
            this.disclaimerShown = false;
        }
    },
    template: `
	<div>
        <h4>{{shortTitle}}</h4>
      	<a href="#" @click.prevent="showDisclaimer" v-html="shortValue"></a>
        <b-modal v-model="disclaimerShown">            
            <header class="modal-card-head">
                <p class="modal-card-title">{{longTitle}}</p>
                <button type="button" class="delete" @click="discard" />
            </header>
            <section class="modal-card-body">
                <div class="card">
                    <div class="card-content" v-html="longValue"></div>
                </div>
            </section>
        </b-modal>
	</div>
	`
});